import ApiManager, {RequestType} from '../ApiManager';
import {SignInWithSocialNetworksResponse} from './AuthApiModels';

export interface IAuthApiManager {
  signInWithSocialNetworks: (
    serverAuthCode: string,
  ) => Promise<SignInWithSocialNetworksResponse>;
  refreshToken: (refreshToken: string) => Promise<void>;
  signOut: (accessToken: string) => Promise<void>;
}

export default class AuthApiManager implements IAuthApiManager {
  signInWithSocialNetworks = (serverAuthCode: string | null) => {
    return ApiManager.request<SignInWithSocialNetworksResponse>(
      RequestType.signInWithSocialNetworks,
      {
        body: {
          serverAuthCode,
        },
      },
    );
  };

  refreshToken = (refresh_token: string) => {
    return ApiManager.request<void>(RequestType.refreshToken, {
      body: {
        refresh_token,
      },
    });
  };

  signOut = (access_token: string) => {
    return ApiManager.request<void>(RequestType.signOut, {
      body: {
        access_token,
      },
    });
  };
}
